/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskOverviewCategory = {
  /**
   * Policy category key.
   */
  category: string;
  /**
   * Finding count for this category.
   */
  findings: number;
};

/** @internal */
export const RiskOverviewCategory$inboundSchema: z.ZodMiniType<
  RiskOverviewCategory,
  unknown
> = z.object({
  category: z.string(),
  findings: z.int(),
});

export function riskOverviewCategoryFromJSON(
  jsonString: string,
): SafeParseResult<RiskOverviewCategory, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskOverviewCategory$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskOverviewCategory' from JSON`,
  );
}
